import type { AxiosError } from 'axios';
import axios from 'axios';

import { AXIOS_CONFIG, MAX_RETRY_COUNT, PROGRESSIVE_DELAY } from './constants';
import { isSkipRetry } from './isSkipRetry';

declare module 'axios' {
  interface AxiosRequestConfig {
    _currentRetry?: number;
    _retryDelay?: number;
  }
}

/**
 * @deprecated использовать RTK Query вместо axios
 * Использовать для НЕ идемпотентных запросов,
 * которые могут создавать дубли записей в БД
 * */
export const axiosWithoutRetries = axios.create(AXIOS_CONFIG);

/**
 * @deprecated использовать RTK Query вместо axios
 * Использовать для идемпотентных запросов,
 * которые не вызовут дублирования данных на бэке
 * */
export const axiosWithRetry = axios.create({
  ...AXIOS_CONFIG,
  _currentRetry: MAX_RETRY_COUNT,
  _retryDelay: 1000,
});

axiosWithRetry.interceptors.response.use(undefined, (err: AxiosError) => {
  const { config, response } = err || {};

  if (!config?._currentRetry) {
    return Promise.reject(err);
  }

  if (isSkipRetry(response?.status)) {
    config._currentRetry = 0;
    return Promise.reject(err);
  }

  config._currentRetry -= 1;

  const delayRetryRequest = new Promise((resolve) => {
    setTimeout(
      () => {
        resolve(err);
      },
      PROGRESSIVE_DELAY[String(config._currentRetry)] || config._retryDelay,
    );
  });

  return delayRetryRequest.then(() => axiosWithRetry(config));
});
